/**
 * Retorna o primeiro e-mail de um campo agregado pelo índice de busca do
 * InsureMO, que concatena o `Email` de todos os `PolicyCustomer` (estipulante
 * + subestipulantes). Nas listagens exibimos só o do estipulante — o primeiro
 * segmento — igual ao que `firstNameSegment` faz com `Nome`/`CPF`.
 *
 * Separa por qualquer espaço em branco (`\n` é o separador do índice), `;` e
 * `,`: nenhum deles é válido dentro de um endereço de e-mail, então o corte é
 * seguro mesmo se o índice mudar de separador. Para uma policy com 1 customer,
 * retorna o próprio valor.
 */
export function firstEmailSegment(value?: string | null): string {
  if (!value) return '';
  const [first] = value
    .split(/[\s;,]+/)
    .map(part => part.trim())
    .filter(Boolean);
  return first ?? '';
}
